import { t } from "i18n";
/*
 * @Descripttion:
 * @version:
 * @Author: zhubaodong
 * @Date: 2021-12-02 16:28:41
 * @LastEditors: zhubaodong
 * @LastEditTime: 2021-12-02 19:48:59
 */
import day from "dayjs";
export function getOrderStatus(status: number) {
  switch (status) {
    case 0:
      return t("src_filters_index_9c58505d");
    case 1:
      return t("src_filters_index_9246fe88");
    case 2:
      return t("src_filters_index_bf738a31");
    case 3:
      return t("src_filters_index_21d63bab");
    default:
      return "";
      break;
  }
}

export function getStatusColor(status: number) {
  switch (status) {
    case 0:
      return "gray";
    case 1:
      return "red";
    case 2:
      return "red";
    case 3:
      return "green";
    default:
      return "";
      break;
  }
}

export function getMallOrderStatus(status: string) {
  switch (+status) {
    case 0:
      return "";
    case 1:
      return "";
    case 2:
      return "";
    case 3:
      return t("src_filters_index_d8476e0a");
    case 4:
      return t("src_filters_index_355409eb");
    case 5:
      return t("src_filters_index_330363df");
    case 6:
      return t("src_filters_index_acd5cb84");
    default:
      return "";
      break;
  }
}
export function getMallStatusColor(status: string) {
  switch (+status) {
    case 0:
      return "";
    case 1:
      return "";
    case 2:
      return "";
    case 3:
      return "yellow";
    case 4:
      return "blue";
    case 5:
      return "green";
    case 6:
      return "red";
    default:
      return "";
      break;
  }
}

export function formatTime(time: number, type: string) {
  let formatType = type ? type : "YYYY-MM-DD HH:mm";
  return (time && day.unix(time).format(formatType)) || "--";
}
